import * as moment from 'moment'

export class SettingsModel {
  id: number
  administration_id: number
  coc_number: string
  vat_number: string
  has_vat: boolean
  company_name: string
  address_street: string
  address_number: number
  address_number_addition: string
  address_postal_code: string
  address_city: string
  address_country: string
  iban: string
  recipient_name: string
  email_address: string
  website: string
  phone_number: string
  mobile_number: string
  push_enabled: string
  sbi: any
  start_date: any

  constructor(settings) {
    {
      this.id = settings.id
      this.administration_id = settings.administration_id
      this.coc_number = settings.coc_number
      this.vat_number = settings.vat_number
      this.has_vat = settings.has_vat ? settings.has_vat : true
      this.company_name = settings.company_name
      this.address_street = settings.address_street
      this.address_number = settings.address_number
      this.address_number_addition = settings.address_number_addition
      this.address_postal_code = settings.address_postal_code
      this.address_city = settings.address_city
      this.address_country = settings.address_country
      this.iban = settings.iban
      this.recipient_name = settings.recipient_name
      this.email_address = settings.email_address
      this.phone_number = settings.phone_number
      this.mobile_number = settings.mobile_number
      this.push_enabled = settings.push_enabled
      this.sbi = settings.sbi
      this.website = settings.website
      this.start_date = settings.start_date ? moment(settings.start_date) : null
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/settings.model.ts